// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bots_transactions_filter_container {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 15px;
}

.bot_title_span {
    font-size: medium;
    font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/bots/BotUserTransactions/botUserTransactions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".bots_transactions_filter_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  gap: 15px;\n}\n\n.bot_title_span {\n    font-size: medium;\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
